import React from "react";

import { useTranslation } from "utils";

import { CropMixComposerGoalResponse } from "models";

import { Table } from "components";

import { CMC_ROUTES } from "pages/app/crop-mix-composer/CropMixComposerOverlay";

export const CropMixSummaryTable = ({ selectedCrops }: { selectedCrops: CropMixComposerGoalResponse[] }) => {
  const { t } = useTranslation("cropMixComposer");

  const summaryCropsOverviewTableColumns = [
    {
      title: "Label",
      dataIndex: "label",
      key: "label",
      className: "label-column",
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
      className: "value-column",
    },
  ];

  const summaryTableData = [
    {
      key: "crops",
      label: t(`page.${CMC_ROUTES.OVERVIEW}.mixSummary.crops`),
      value: selectedCrops.length,
    },
    {
      key: "families",
      label: t(`page.${CMC_ROUTES.OVERVIEW}.mixSummary.families`),
      value: new Set(selectedCrops.map((crop: CropMixComposerGoalResponse) => crop.crop.cropFamily)).size,
    },
    {
      key: "minGrowingPeriod",
      label: t(`page.${CMC_ROUTES.OVERVIEW}.mixSummary.minGrowingPeriod`),
      value: Math.max(...selectedCrops.map((crop: CropMixComposerGoalResponse) => crop.weightDistributionParams.minimumGrowTimeWeeks)),
    },
  ];

  return <Table className="mix-summary-table" columns={summaryCropsOverviewTableColumns} data={summaryTableData} hideHeader={true} />;
};
